import { isMediaEvent } from "src/modules/activity-log/supported-events";

export function getMonitoring(state, id) {
  return state.activityLog.monitoringsById[id];
}

export function getMonitorings(state) {
  return state.activityLog.monitoringsById;
}

export function getMonitoringsToDelete(state) {
  const monitorings = Object.values(getMonitorings(state));

  return monitorings.filter((monitoring) => {
    if (!monitoring.isStructureUploaded) return false;

    const hasMediaToUpload = monitoring.events.some(
      (event) => event.fileName && !event.isMediaUploaded
    );
    if (hasMediaToUpload) return false;

    return true;
  });
}

export function getPendingAudioEvents(state) {
  const media = [];
  const monitorings = Object.values(getMonitorings(state));
  monitorings.forEach((monitoring) => {
    monitoring.events.forEach((event) => {
      if (
        event.eventType === "AWAKE" &&
        event.fileName &&
        !event.isMediaUploaded
      ) {
        media.push({
          eventType: event.eventType,
          fileName: event.fileName,
          monitoringId: monitoring.monitoringId
        });
      }
    });
  });
  return media;
}
export function getPendingCaptureEvents(state) {
  const media = [];
  const monitorings = Object.values(getMonitorings(state));
  monitorings.forEach((monitoring) => {
    monitoring.events.forEach((event) => {
      const isCaptureEvent = isMediaEvent(event.eventType);
      if (isCaptureEvent && event.fileName && !event.isMediaUploaded) {
        media.push({
          eventType: event.eventType,
          fileName: event.fileName,
          monitoringId: monitoring.monitoringId
        });
      }
    });
  });
  return media;
}

export function getDismissedAfterFirstMediaCaptureDialog(state) {
  return state.activityLog.dismissedAfterFirstMediaCaptureDialog;
}

export function getOpenedDescription(state) {
  return state.activityLog.openedDescription;
}

export function getStorageId(state) {
  return state.activityLog.storageId;
}

export function getNoiseCapture(state) {
  return state.activityLog.noiseCapture;
}

export function getMotionCapture(state) {
  return state.activityLog.motionCapture;
}
